
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/media",
      function () {
        return require("private-next-pages/[locale]/media.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/media"])
      });
    }
  